import { set } from 'lodash';

const resourcesToArray = obj =>
  Object.keys(obj).map(key => ({
    ...obj[key],
    columns: obj[key].columns && resourcesToArray(obj[key].columns),
  }));

const resourcesToObject = resources =>
  resources.reduce((acc, field) => {
    const slug = field.slug.replace('.', '.columns.');

    // eslint-disable-next-line no-unused-expressions
    acc[slug] ? { ...acc[slug], field } : set(acc, slug, field);

    return acc;
  }, {});

export const prepareResources = resources =>
  resourcesToArray(resourcesToObject(resources));
